import { combineReducers } from '@reduxjs/toolkit'
import { appReducer } from './app'
import { conditionsReducer } from './conditions'
import { entriesReducer } from './entries'
import { operationsReducer } from './operations'
import { dataSourceContextParamsReducer } from './dataSourceContextParams'
import { sectionsReducer } from './sections'
import { sheetsReducer } from './sheets'

export default combineReducers({
  app: appReducer,
  conditions: conditionsReducer,
  entries: entriesReducer,
  operations: operationsReducer,
  sections: sectionsReducer,
  sheets: sheetsReducer,
  dataSourceContextParams: dataSourceContextParamsReducer,
})
